<template>
    <div ref="container" class='position-relative h-100'>
        <loading ref="loading"></loading>

        <b-modal centered ref="documentDownloadDialog" title="" size="lg">
			<div class="text-center">
				<p v-if='!document_download.data'>{{ $t('translations.preparing_download') }}</p>
                <div v-else class="d-flex flex-column mr-1 align-items-center">
                    <p class='align-self-center'>{{document_download.name}}</p>
                    <a v-on:click='$refs.documentDownloadDialog.hide(); initDocumentDownload($event, document_download, document_download.name)' v-if='document_download.data' class='btn btn-lg btn-primary' :href='document_download.data' :download='document_download.name'>{{ $t('translations.download') }}</a>
                </div>
			</div>
			<!-- <img :width='full_image.width' :height='full_image.height' style='max-width: 100%; max-height: 100%;' :src='full_image.data'> -->
			<div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="primary" v-on:click.prevent='$refs.documentDownloadDialog.hide()'>
					{{ $t('translations.close') }}
				</b-btn>
			</div>
		</b-modal>

        <div class="card d-flex flex-column h-100">

            <header class="list-header" style="z-index: 100;">
                <h2 class="p-2">{{getName()}}&nbsp; <span v-if='event == "patient"' class="float-right h5" v-b-tooltip :title="autobrand('translations.patientID')"><span class="copyTextContent" v-on:click="copyTextContent(item.id)">{{item.id}}</span></span></h2>
            </header>

            <div class="card-body flex-grow-1-scroll">
                <div class="errors">
                    <template v-for="(error, key) in errors">
                        <p class="alert alert-warning" v-for="message in error">{{message}}</p>
                    </template>
                </div>
                <component v-bind:item-name='item.name' v-bind:is='displayelement' ref='subComponent'
                    :item='item' :event='event'></component>

            </div>

            <footer class='container-footer'>
                <button v-if='event == "patient"' class="btn btn-success btn-round mr-1" v-on:click.prevent='createNewRequest' role="button">{{ autobrand('translations.create_new_request_provider')}}</button>
                <button v-if='event == "staff" || event == "patient"' class="btn btn-secondary btn-round mr-1" v-on:click.prevent='viewActivity' role="button">{{ $t('translations.view_activity')}}</button>
                <button v-if='event == "staff" && this.item.provider.demo_mode == 1 && this.item.user_provider.length == 1' class="btn btn-success btn-round mr-1" v-on:click.prevent='addDemoQuestions' role="button">{{ $t('translations.reset_demo_questions')}}</button>

                <button v-if='(event == "staff" || event == "patient") && this.item.email' class="btn btn-primary btn-round mr-1" role="button" id="email_notification" value="1" v-on:click="sendWelcomeEmail">{{ $t('translations.send_welcome_email_password')}}</button>
                <button v-if='event == "patient"' class="btn btn-secondary btn-round mr-1" role="button" v-on:click="generateSar">{{$t('translations.sar')}}</button>
                <button v-if='canEdit()' class="btn btn-primary btn-round float-right" v-on:click.prevent='openEdit' role="button">{{ $t('translations.edit')}}</button>
            </footer>

        </div>
    </div>
</template>


<script>

	export default {
		props: [
			'route',
            'event',
			'model',
			'path',
            'displayelement',
            'elementname',

		],
        data: function(){
			return {
				item: {name: "", email: "", provider: {name: ""} },
                errors: [],
                itemName: "",
                document_download: {name: null, data: null},
			};
		},
		mounted() {
            this.errors = [];
            // Register event listener
            this.loadItem();

        },
		methods: {
            getName() {
                if(this.$refs.subComponent && this.$refs.subComponent.getName) {
                    return this.$refs.subComponent.getName();
                }
                else {
                    return this.item.name;
                }
            },
			loadItem() {
                this.setLoading(true);

                var userId;
                if(this.$route.params.id) {
                    userId = this.$route.params.id;
                }
                else {
                    userId = this.$root.user.id;
                }

                axios.get(this.route + '/' + userId).then((res) => {
					//console.log("res.data: " + JSON.stringify(res.data, null, 2));

					this.item = res.data[this.model];

                    this.setLoading(false);
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/" + this.event + "-list"});
                });
            },

            openEdit(event) {
                var route = {path: "/" + this.event + "-list" + "/" + this.event + '-edit/' + this.item.id};
                
                if(this.$refs.subComponent.tabs && this.$refs.subComponent.tabIndex) {
                    route.path += this.$refs.subComponent.tabs[this.$refs.subComponent.tabIndex];
                }
                
                this.$router.push(route);
			},
            createNewRequest() {
                this.$router.push({path: "/thread-list/thread-create/" + this.item.id});
            },
            viewActivity() {
                
                this.$router.push({name: "logList", params: {subject_object_id: this.item.id}});
            },
            canEdit() {
				if(this.event == "thread") {
					return false;
				}
				if(this.event == "staff" && (this.is_admin() || this.is_superuser() || this.is_network_admin())) {
					return true;
				}
				if(this.event == "patient") {
					return true;
				}
				if(this.event == "usergroup" && (this.is_admin() || this.is_superuser())) {
					return true;
				}
                if(this.event == "news" && this.is_network_admin()) {
					return true;
				}
                if(this.event == "presetmessage") {
                    if(this.item.user_id == this.$root.user.id) {
                        return true;
                    }

                    if((this.is_admin() || this.is_superuser()) && this.item.user_id == null && this.item.provider_id != null) {
                        return true;
                    }

                    if(this.is_network_admin()) {
                        return true;
                    }
				}
                if(this.event == "provider" && (this.is_network_admin())) {
					return true;
				}
				return false;
			},

            sendWelcomeEmail() {
                this.setLoading(true);
                var path = this.$root.apiBase + '/users/sendWelcomeEmail/' + this.item.id;
                if(this.is_network_admin()) {
                    path += "/" + this.item.provider.id;
                }
                axios.post(path, this.item.id).then((res) => {
                    this.setLoading(false);
                    this.addNotification({type: "success", content: "Welcome email has been sent"});
                    console.log(res.data);

				}).catch((error) => {
                    this.setLoading(false);
                    //this.handleError(error, "create");
                });
            },
            generateSar() {
                this.$refs.documentDownloadDialog.show();
                this.document_download = {data: null, name: null};
                axios.get(this.$root.apiBase + '/patients/produceSubjectAccessRequest/' + this.item.id, { responseType: 'arraybuffer' }).then((res) => {
                    this.document_download.name = "subject_access_request-" + this.item.id + "-" + this.moment().format("YYYY-MM-DD\THH-mm-ss") + ".pdf";
                    let documentRaw = btoa(
                        new Uint8Array(res.data)
                            .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );

                    this.document_download.data = `data:${res.headers['content-type'].toLowerCase()};base64,${documentRaw}`;

				}).catch((error) => {
                    this.$refs.documentDownloadDialog.hide();
                    this.addNotification({type: "danger", timeout: 0, content: "Download of history failed"});
                });
            },
            dataUrlToBlob(strUrl) {
                var myBlob = (window.Blob || window.MozBlob || window.WebKitBlob || toString);
                var parts= strUrl.split(/[:;,]/),
                type = parts[1],
                indexDecoder = strUrl.indexOf("charset")>0 ? 3: 2,
                decoder = parts[indexDecoder] == "base64" ? atob : decodeURIComponent,
                binData = decoder( parts.pop() ),
                mx = binData.length,
                i = 0,
                uiArr = new Uint8Array(mx);

                for(i;i<mx;++i) {
                    uiArr[i]= binData.charCodeAt(i);
                }

                return new myBlob([uiArr], {type: type});
            },
            initDocumentDownload(event, document, name) {
                this.$refs.documentDownloadDialog.hide();
                if(navigator && navigator.msSaveBlob) {
                    navigator.msSaveBlob(this.dataUrlToBlob(document.data), name);
                    event.preventDefault();
                }
            },
            addDemoQuestions() {
                this.setLoading(true);
                axios.post(this.$root.apiBase + '/users/addDemoQuestions/' + this.item.id, this.item.id).then((res) => {
                    this.setLoading(false);
                    this.addNotification({type: "success", content: "Demo questions added to user"});
                    console.log(res.data);

				}).catch((error) => {
                    this.setLoading(false);
                    //this.handleError(error, "create");
                });
            }
        }
    }
</script>
